import { connect } from 'react-redux';
import Customers from './components/Customers';
import {
  loadCustomerOrganizationsList,
  loadCustomerOrganizationsListPage,
  createCustomerOrganization,
  updateCustomerOrganization,
  loadCustomerSubscriptionPlan,
  createCustomerSubscription,
  updateCustomerSubscription,
  restrictSubscriptionCustomerOrganization,
  unrestrictSubscriptionCustomerOrganization,
  notifySubscriptionRestrictedCustomerOrganization,
  deleteCustomerOrganization,
  resetCreateOrganizationStatus,
  setOrganizationActive,
  resetSetOrganizationActiveStatus,
  setOrganizationInactive,
  resetSetOrganizationInactiveStatus,
} from '../../redux/actions/staff';
import { changeTitle } from '../../redux/actions/app';
import { loadMySubscriptionPlan } from '../../redux/actions/user';
import { loadBulkDataFeedOptions } from '../../redux/actions/bulkData';
import { loadDataMarketplaceFeedOptions } from '../../redux/actions/marketPlace';

const mapStateToProps = (state) => ({
  customerOrganizationsStatus: state.staff.customerOrganizationsStatus,
  customerOrganizationsCreationStatus:
    state.staff.customerOrganizationsCreationStatus,
  customerOrganizationsCount: state.staff.customerOrganizationsCount,
  customerOrganizationsData: state.staff.customerOrganizationsData,
  customerOrganizationsCreationData:
    state.staff.customerOrganizationsCreationData,
  customerOrganizationSubscription:
    state.staff.customerOrganizationSubscription,
  customerOrganizationSubscriptionStatus:
    state.staff.customerOrganizationSubscriptionStatus,
  customerSubscriptionPlanStatus: state.staff.customerSubscriptionPlanStatus,
  customerSubscriptionPlan: state.staff.customerSubscriptionPlan,
  mySubscriptionPlan: state.user.mySubscriptionPlan,
  mySubscriptionPlanStatus: state.user.mySubscriptionPlanStatus,
  setOrganizationActiveStatus: state.user.setOrganizationActiveStatus,
  setOrganizationInactiveStatus: state.user.setOrganizationInactiveStatus,

  bulkDataFeedOptions: state.bulkdata.bulkDataFeedOptions, //remove after transition
  bulkDataFeedOptionsStatus: state.bulkdata.bulkDataFeedOptionsStatus, //remove after transition

  dataMarketplaceFeedOptions: state.marketplace.dataMarketplaceFeedOptions,
  dataMarketplaceFeedOptionsStatus:
    state.marketplace.dataMarketplaceFeedOptionsStatus,
});

const mapDispatchToProps = {
  changeTitle,
  loadCustomerOrganizationsList,
  loadCustomerOrganizationsListPage,
  createCustomerOrganization,
  updateCustomerOrganization,
  loadCustomerSubscriptionPlan,
  createCustomerSubscription,
  updateCustomerSubscription,
  restrictSubscriptionCustomerOrganization,
  unrestrictSubscriptionCustomerOrganization,
  notifySubscriptionRestrictedCustomerOrganization,
  deleteCustomerOrganization,
  loadMySubscriptionPlan,
  resetCreateOrganizationStatus,
  setOrganizationActive,
  resetSetOrganizationActiveStatus,
  setOrganizationInactive,
  resetSetOrganizationInactiveStatus,

  loadBulkDataFeedOptions,
  loadDataMarketplaceFeedOptions,
};

export default connect(mapStateToProps, mapDispatchToProps)(Customers);
